import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToCta = () => {
    const element = document.getElementById('final-cta');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="min-h-screen w-full flex items-center justify-center relative overflow-hidden pt-20 pb-10 px-6" data-id="element-85">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-86" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-blue-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-87" />

      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-88">
        {/* Left Column: Copy */}
        <div className="flex flex-col space-y-8 z-10" data-id="element-89">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-90">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] tracking-tight mb-4" data-id="element-91">
              Por qué siempre terminás como{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-92">
                amigo
              </span>
            </h1>
            <p className="text-lg md:text-xl text-gold font-medium tracking-wide" data-id="element-93">
              (y cómo romper ese patrón sin manipular, actuar ni ser otro)
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: [0.25, 0.1, 0.25, 1]
        }} className="space-y-6 text-gray-300 text-lg leading-relaxed max-w-xl" data-id="element-94">
            <p data-id="element-95">
              Hiciste todo bien. Escuchaste, respetaste, esperaste. Y aun así...
              terminaste siendo el amigo.
            </p>
            <p data-id="element-96">No es mala suerte. Es un patrón. Y tiene solución.</p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.25, 0.1, 0.25, 1]
        }} data-id="element-97">
            <button onClick={scrollToCta} className="bg-gold hover:bg-gold-light text-primary font-bold text-lg py-4 px-10 rounded-sm transition-all duration-300 transform hover:scale-[1.02] shadow-[0_0_20px_rgba(201,168,76,0.3)]" data-id="element-98">
              Acceder al sistema ahora
            </button>
          </motion.div>
        </div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="relative z-10 flex justify-center lg:justify-end" data-id="element-99">
          <div className="relative w-full max-w-md lg:max-w-lg" data-id="element-100">
            <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-30 transform scale-90" data-id="element-101" />
            <img src="https://cdn.magicpatterns.com/uploads/dUCumyGdRDtNLM4eLMGY7t/Generated_Image_February_11,_2026_-_11_47PM.jpg" alt="The F-Formula Product" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-white/10" data-id="element-102" />
          </div>
        </motion.div>
      </div>
    </section>;
}